import { useState } from 'react'
import { Icon } from '@iconify/react'

export default function CustomDropDownList({ options, onSelect, title }) {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState(null)

  const handleSelect = (option) => {
    if (selectedOption?.value === option.value) {
      setSelectedOption(null)
      onSelect(null)
    } else {
      setSelectedOption(option)
      onSelect(option.value)
    }
    setIsOpen(false) // Đóng dropdown sau khi chọn
  }

  const handleToggle = () => setIsOpen(!isOpen)

  return (
    <div className="relative inline-block text-left">
      <button
        className={`hover:bg-gray-secondar w-[190px] rounded-lg border bg-white px-3 py-1 text-gray-accent focus:outline-none lg-c:w-[220px] lg-c:px-4 lg-c:py-2`}
        onClick={handleToggle}
      >
        <div className="flex items-center justify-between">
          {selectedOption ? (
            <>
              <span>{selectedOption.label}</span>
            </>
          ) : (
            <>
              <span>{title}</span>
            </>
          )}
          <Icon icon="ph:caret-down-bold" className="text-2xl text-black" />
        </div>
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-1 flex w-[190px] flex-wrap overflow-y-auto rounded-lg border border-gray-300 bg-white shadow-lg transition-opacity duration-300 ease-in-out lg:w-[200px]">
          <ul className="w-full">
            {options.map((option) => (
              <li
                key={option.value}
                className={`text-gray w-full cursor-pointer px-2 py-2 ${
                  selectedOption?.value === option.value
                    ? 'bg-gray-200 hover:bg-gray-300'
                    : 'hover:bg-gray-100'
                }`}
                onClick={() => handleSelect(option)}
              >
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
